import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vaccine-schemas',
  templateUrl: './vaccine-schemas.component.html',
  styleUrls: ['./vaccine-schemas.component.scss']
})
export class VaccineSchemasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
